import URI from "urijs";
import { normalizeItemUris, normalizeUri } from "./normalizeUri";
import ITabMenuContentItem from "../models/ITabMenuContentItem";

export const isDocMenuItemSelected = (rawItem: ITabMenuContentItem) => {
  const item = normalizeItemUris(rawItem);
  if (item.href) {
    const curHref = normalizeUri(
      URI(window.location.href)
        .resource()
        .toLowerCase(),
    );

    if (curHref === item.href) {
      return true;
    }
    if (item.exactMatches && item.exactMatches.filter(match => curHref === match).length > 0) {
      return true;
    }
    if (item.startMatches && item.startMatches.filter(match => curHref.startsWith(match)).length > 0) {
      return true;
    }
  }
  return false;
};
